import { render, staticRenderFns } from "./Design.vue?vue&type=template&id=2a69c1bb&scoped=true&"
import script from "./Design.vue?vue&type=script&lang=js&"
export * from "./Design.vue?vue&type=script&lang=js&"
import style0 from "./Design.vue?vue&type=style&index=0&id=2a69c1bb&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a69c1bb",
  null
  
)

export default component.exports